import { render, staticRenderFns } from "./cancelOrder.vue?vue&type=template&id=0af08270&scoped=true&"
import script from "./cancelOrder.vue?vue&type=script&lang=js&"
export * from "./cancelOrder.vue?vue&type=script&lang=js&"
import style0 from "./cancelOrder.vue?vue&type=style&index=0&id=0af08270&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af08270",
  null
  
)

export default component.exports